"use client";

import { c as _c } from "react/compiler-runtime";
import { useLocale } from "next-intl";
import type { Locale } from "@/i18n/config";
import { ImageCarouselMultiple } from "@/components/image-carousel/image-carousel-multiple";
import { ImageCarouselSingle } from "@/components/image-carousel/image-carousel-single";
import type { CarouselSlide } from "@/components/image-carousel/image-carousel.types";
import { LayoutHeader } from "@/components/common/layout-header";
import type { PagebuilderType } from "@/lib/types";
import { nullToUndefined } from "@/lib/utils";
type ImageCarouselBlockProps = PagebuilderType<"imageCarousel">;
type SlideData = NonNullable<NonNullable<ImageCarouselBlockProps["carousel"]>["slides"]>[number];
function toSlide(slide: SlideData): CarouselSlide | null {
  if (!slide.customImage?.image?.asset) return null;
  return {
    key: slide.key,
    // Bridge mediaSource item into VisualType shape for VisualWrapper
    visual: {
      mediaSource: slide
    } as CarouselSlide["visual"],
    caption: nullToUndefined(slide.caption)
  };
}
export function ImageCarouselBlock(t0) {
  const $ = _c(15);
  const {
    header,
    carousel
  } = t0;
  const locale = useLocale() as Locale;
  if (!carousel) {
    return null;
  }
  let t1;
  if ($[0] !== carousel.slides) {
    t1 = (carousel.slides ?? []).map(toSlide).filter(_temp);
    $[0] = carousel.slides;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const slides = t1;
  if (!slides.length) {
    return null;
  }
  let t2;
  if ($[2] !== carousel._type || $[3] !== slides) {
    t2 = className => {
      switch (carousel._type) {
        case "imageCarouselSingle":
          {
            return <ImageCarouselSingle slides={slides} className={className} />;
          }
        case "imageCarouselMultiple":
          {
            return <ImageCarouselMultiple slides={slides} className={className} />;
          }
        default:
          {
            return null;
          }
      }
    };
    $[2] = carousel._type;
    $[3] = slides;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const renderCarousel = t2;
  if (!header || header._type === "plain") {
    let t3;
    if ($[5] !== renderCarousel) {
      t3 = renderCarousel();
      $[5] = renderCarousel;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  let t3;
  if ($[7] !== header || $[8] !== locale) {
    t3 = <LayoutHeader item={header} locale={locale} />;
    $[7] = header;
    $[8] = locale;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== renderCarousel) {
    t4 = renderCarousel("pt-0 desktop:pt-0");
    $[10] = renderCarousel;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
function _temp(s) {
  return s !== null;
}